let cashfreeSdkLoadPromise = null;

/**
 * Load Cashfree JS SDK v3 once (shared across concurrent callers).
 */
export function loadCashfreeSdk() {
  if (typeof window === "undefined") {
    return Promise.reject(new Error("Cashfree checkout requires a browser"));
  }
  if (window.Cashfree) {
    return Promise.resolve();
  }
  if (!cashfreeSdkLoadPromise) {
    cashfreeSdkLoadPromise = new Promise((resolve, reject) => {
      const s = document.createElement("script");
      s.src = "https://sdk.cashfree.com/js/v3/cashfree.js";
      s.async = true;
      s.onload = () => resolve();
      s.onerror = () => {
        cashfreeSdkLoadPromise = null;
        reject(new Error("Failed to load Cashfree checkout SDK"));
      };
      document.body.appendChild(s);
    });
  }
  return cashfreeSdkLoadPromise;
}

function cashfreeMode(cashfreeEnv) {
  return cashfreeEnv === "production" ? "production" : "sandbox";
}

/**
 * Hosted subscription checkout (standard plans).
 */
export async function openCashfreeSubscriptionCheckout({
  subscriptionSessionId,
  cashfreeEnv,
  redirectTarget = "_self",
}) {
  await loadCashfreeSdk();
  const cf = window.Cashfree({ mode: cashfreeMode(cashfreeEnv) });
  if (typeof cf.subscriptionsCheckout !== "function") {
    throw new Error("Cashfree subscriptionsCheckout is not available");
  }
  await cf.subscriptionsCheckout({
    subsSessionId: subscriptionSessionId,
    redirectTarget,
  });
}

/**
 * One-time payment order checkout (custom plan).
 */
export async function openCashfreeOrderCheckout({
  paymentSessionId,
  cashfreeEnv,
  redirectTarget = "_self",
}) {
  await loadCashfreeSdk();
  const cf = window.Cashfree({ mode: cashfreeMode(cashfreeEnv) });
  if (typeof cf.checkout !== "function") {
    throw new Error("Cashfree checkout is not available");
  }
  await cf.checkout({
    paymentSessionId,
    redirectTarget,
  });
}
